import React from 'react';
import { Link } from 'react-router-dom';
import HeroCarousel from './Hero_Carousel';
import ArticleCarousel from './Article_Carousel';
import OptimizedImage from './OptimizedImage';
import './Home.css';

const Arrow = () => <span aria-hidden="true">&rarr;</span>;

const Home = () => (
  <div className="home">
    <HeroCarousel />

    {/* ---------- Lede ---------- */}
    <section className="lede">
      <p className="eyebrow">Zach Robers</p>
      <h2>
        Mathematical and computational tools for problems in science and
        society.
      </h2>
      <p>
        My work has ranged from fluid dynamics and heat diffusion to machine
        learning, spatial biology, and proprietary trading. Alongside
        research, I spend much of my time teaching, mentoring, and building
        organizations around education and community.
      </p>
      <div className="meta">
        <span>Duke University</span>
        <i className="meta-dot" />
        <span>Mathematics &amp; Computer Science</span>
        <i className="meta-dot" />
        <span>Durham, NC</span>
      </div>
    </section>

    {/* ---------- Page segues ---------- */}
    <section className="tiles" aria-label="Explore">
      <Link to="/research" className="tile tile--wide">
        <div className="tile-bg">
          <OptimizedImage
            webpSrc="/images/optimized/cells.webp"
            fallbackSrc="/images/cells.png"
            alt="Spatial transcriptomics tissue map"
          />
        </div>
        <div className="tile-veil" />
        <div className="tile-body">
          <p className="tile-eyebrow">Research</p>
          <h3>Spatial biology, protein structure, and fluid dynamics.</h3>
          <p className="tile-text">
            A diffusion-based framework for generating cellular-resolution
            tissue at the Hickey Lab, geometric methods for comparing protein
            surfaces in the Donald Lab, and a multi-year study of how geometry
            shapes heat diffusion, with several of these now manuscripts under
            review.
          </p>
          <span className="tile-cta">
            View research <Arrow />
          </span>
        </div>
      </Link>

      <Link to="/projects" className="tile tile--texture">
        <div className="tile-bg">
          <OptimizedImage
            webpSrc="/images/optimized/software.webp"
            fallbackSrc="/images/software.png"
            alt="Source code from a modeling project"
          />
        </div>
        <div className="tile-veil" />
        <div className="tile-body">
          <p className="tile-eyebrow">Projects</p>
          <h3>Things I&rsquo;ve built.</h3>
          <p className="tile-text">
            ConnectU, an AI-driven mentorship platform I co-founded,
            interpretable models for M&amp;A decisions, and clustering methods
            for rental pricing.
          </p>
          <span className="tile-cta">
            View projects <Arrow />
          </span>
        </div>
      </Link>

      <Link to="/nonprofit" className="tile tile--light">
        <div className="tile-body">
          <div className="tile-logos">
            <img src="/images/sailea.png" alt="SAILea" />
            <img src="/images/echhsaa.png" alt="ECHHS Alumni Association" />
          </div>
          <p className="tile-eyebrow">Nonprofit</p>
          <h3>Organizations for education and community.</h3>
          <p className="tile-text">
            I founded and chair the East Chapel Hill High School Alumni
            Association. I previously chaired the Scholastic Artificial
            Intelligence League, a network of more than 100 high school AI
            clubs across four continents.
          </p>
          <span className="tile-cta">
            Learn more <Arrow />
          </span>
        </div>
      </Link>
    </section>

    {/* ---------- Thought leadership ---------- */}
    <section className="band">
      <div className="section-head">
        <h2>Thought Leadership</h2>
        <p>
          Essays on the ethics and philosophy of AI, which I studied at Oxford,
          on leadership in a digital age, and on the classical world.
        </p>
      </div>
      <ArticleCarousel />
      <div className="band-footer">
        <Link to="/thought-leadership" className="text-link">
          All essays <Arrow />
        </Link>
      </div>
    </section>

    {/* ---------- Closing ---------- */}
    <section className="closing">
      <h2>Get in touch.</h2>
      <p>
        I&rsquo;m interested in research collaborations, early-stage ideas, and
        problems that need modeling.
      </p>
      <Link to="/contact" className="pill">
        Contact <Arrow />
      </Link>
    </section>
  </div>
);

export default Home;
